import { useLanguage } from "@/context/LanguageContext";

export default function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();

  return (
    <div className="relative flex items-center rounded-full bg-white/70 p-1 shadow-sm backdrop-blur-md border border-white/50 dark:bg-gray-800/70 dark:border-gray-700/50">
      <button
        onClick={() => setLang("es")}
        className={`relative z-10 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-all duration-300 ${
          lang === "es"
            ? "bg-indigo-600 text-white shadow-md"
            : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        }`}
      >
        ES
      </button>
      <button
        onClick={() => setLang("en")}
        className={`relative z-10 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-all duration-300 ${
          lang === "en"
            ? "bg-indigo-600 text-white shadow-md"
            : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        }`}
      >
        EN
      </button>
    </div>
  );
}